module.exports = __webpack_public_path__ + "static/media/Montserrat-Italic.c47cfa55.ttf";